import _ from 'underscore';
import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';

import { useComponentStylesContext } from './component-styles-provider';

const useNoBaseStyles = () => null;

export function withOverridableStyles(WrappedComponent, useDefaultStyles, useBaseStyles = useNoBaseStyles, options) {
  const {
    componentName,
    baseClassName,
  } = options || {};

  const HOC = (props) => {
    // get the custom styles for the component, which are provided by setting up the ComponentStylesProvider
    const overridenClasses = useComponentStylesContext(componentName);

    const defaultClasses = useDefaultStyles();
    const baseClass = useBaseStyles();

    // shallow merge the default classes with the overriden classes
    const finalBaseClassName = baseClassName || 'baseClassName';
    const finalClasses = { ...defaultClasses, [finalBaseClassName]: baseClass, ...overridenClasses };

    return (
      <WrappedComponent {...props} classes={finalClasses} />
    );
  };

  const componentDisplayName = componentName || WrappedComponent.displayName || WrappedComponent.name || 'Component';

  HOC.displayName = `withComponentStyles(${componentDisplayName})`;

  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
}
